<template>
  <v-container class="ma-1">
    <v-breadcrumbs class="pa-2">
            <v-breadcrumbs-item class="title"><v-icon class="mr-3">mdi-monitor-dashboard</v-icon>Dashboard</v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-card class="py-5" :style="`min-width: ${bodySectionWidth+10}px;`">
      <v-card flat class="mr-1 overflow-auto" v-resize="resizeBodySection" :style="`min-width: ${bodySectionWidth}px;`">
          <v-card-text :style="`height: ${bodySectionHeight}px;`">
            <div :class="`d-flex flex-wrap ${drawerIsOpen&isMobile?'flex-row-reverse':'justify-center'}`">
              <heat-map-network />
              <heat-map-sync />
              <!-- <v-card>
                <v-card-title>Tablet Memory Usage</v-card-title>
                <v-card-text>
                  <heat-map :tablets="tabletInfo" type = "memoryUtilization" :key="Math.random()" />
                </v-card-text>
              </v-card>
              <v-card>
                <v-card-title>Tablet Disk Usage</v-card-title>
                <v-card-text>
                  <heat-map :tablets="tabletInfo" type = "diskUtilization" :key="Math.random()" />
                </v-card-text>
              </v-card>
              <v-card>
                <v-card-title>Tablet Db Size</v-card-title>
                <v-card-text>
                  <heat-map :tablets="tabletInfo" type = "databaseSize" :key="Math.random()" />
                </v-card-text>
              </v-card> -->
            </div>
          </v-card-text>
      </v-card>
   </v-card>
  </v-container>
</template>

<script>
  // import HeatMap from '../components/HeatMap';
  import HeatMapNetwork from '../components/HeatMapNetwork';
  import HeatMapSync from '../components/HeatMapSync';
  import { mapState, mapActions } from "vuex";
  export default {
    name: 'Dashboard',

    components: {
      // HeatMap,
      HeatMapNetwork,
      HeatMapSync
    },

    data: () => ({
      userAuthorized: true,
      isMobile: false,
      drawerIsOpen: false,
      bodySectionHeight: 0,
      bodySectionWidth: 0,
      localTabletInfo: []
    }),
    
    computed: {
      ...mapState(['tabletInfo', 'settings', 'isAuthenticated', 'isOnline', 'userProfile'])
    },
    async created() {
    if (this.isOnline && this.isAuthenticated) {
      try {
        this.isBusy = true;
        await this.initializeTabletInfo();
        this.isBusy = false;
      }
      catch (e) {
        this.isBusy = false;
        console.log(this.userProfile); // eslint-disable-line no-console
        if (e.toString().indexOf("User not authorized") !== -1) {
          this.userAuthorized = false;
        }
        else throw e;
      }
    }
  },
    methods: {
      ...mapActions(['initializeTabletInfo']),
      resizeBodySection() {
        this.bodySectionHeight = window.innerHeight-200;
        this.drawerIsOpen = document.getElementById('tdm-navigation-drawer').getAttribute("class").includes("v-navigation-drawer--open");
        this.isMobile = document.getElementById('tdm-navigation-drawer').getAttribute("class").includes("v-navigation-drawer--is-mobile");
        this.bodySectionWidth = this.drawerIsOpen && !this.isMobile ? window.innerWidth-300 : window.innerWidth-40;
      }
    }
  }
</script>